import React from "react";
import Header from "features/shared/layout/header/Header";
import ModuleContent from "features/shared/layout/content/ModuleContent";
import VersionSection from "features/admin/sections/VersionSection";
import { useTranslation } from "react-i18next";

const VersionPage = () => {
  // translations
  const tLabels = useTranslation("shared\\moduleNames").t;

  return (
    <>
      <Header
        title={tLabels("versionPage.title")}
        includeBreadcrumbs
      />
      <ModuleContent>
        <VersionSection />
      </ModuleContent>
    </>
  );
};

export default VersionPage;